import { useI18n } from "@/context/I18nContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
function continueWithGoogle() {
  const redirectUrl = window.location.origin + "/";
  window.location.href =
    `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

/** Multi-colour Google "G" mark — official brand SVG */
function GoogleIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16.1 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.1 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.6 39.7 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.6l6.2 5.2C40.9 35.9 44 30.5 44 24c0-1.2-.1-2.3-.4-3.5z" />
    </svg>
  );
}

export default function SocialAuthButtons() {
  const { t } = useI18n();
  return (
    <div className="mt-6" data-testid="social-auth-buttons">
      <div className="relative flex items-center my-3">
        <div className="flex-1 border-t border-app-border" />
        <span className="px-3 text-[11px] uppercase tracking-widest text-espresso/50">
          {t("auth.social_divider")}
        </span>
        <div className="flex-1 border-t border-app-border" />
      </div>
      <div className="flex justify-center">
        <button
          type="button"
          onClick={continueWithGoogle}
          aria-label="Continue with Google"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white border border-app-border hover:bg-cream-2 transition-transform hover:scale-[1.02] active:scale-95 text-sm font-semibold text-espresso"
          data-testid="social-google-btn"
        >
          <GoogleIcon className="w-5 h-5" />
          {t("auth.google_button")}
        </button>
      </div>
    </div>
  );
}
